import { AccordionButton } from "@chakra-ui/react";
import React from "react";
import { InfoArrow } from "~misc/icons";

import "./style.scss";
import TableInputTab from "../../DashboardTable/TableInputTab";

const FunnelBasicHeader = ({ header, accordioncfg }) => {
  return (
    <AccordionButton className="funnel-accordion-header basic-header" onClick={(e) => {
      if(accordioncfg?.disable_accordion)
        e.preventDefault();
    }}>
      {typeof header?.layout_fields === "object" ? (
        <div className="content !p-5">
          {header.layout_fields.input ? (
            <>
              {header.layout_fields.label}
              <TableInputTab 
                key={header.layout_fields.id}
                item={header.layout_fields}
              ></TableInputTab>
            </>
          ) : (
            header.label
          )}
          {!accordioncfg?.disable_accordion && (
            <div className="icon-button">
              <InfoArrow className="icon" />
            </div>
          )}
        </div>
      ) : (
        <div className="content">
          {header}
          {!accordioncfg?.disable_accordion && (
            <div className={`icon-button ${header?.props?.data?.header?.actionButtons ? "relative" : ""}`}>
              <InfoArrow className="icon" />
            </div>
          )}
        </div>
      )}
    </AccordionButton>
  );
};

export default FunnelBasicHeader;
